'use strict';

angular.module('AcaApp').factory('AuthenticationService',
[
  '$window',
  '$location',
  'AuthResource',
  'UserService',
  '$interval',
  '$rootScope',
  'LockedScreenService',
  'ManagedUserInformationService',
  function($window, $location, AuthResource, UserService, $interval, $rootScope, LockedScreenService, ManagedUserInformationService){
    var userCredentials = {};
    var internalLogout = function(redirect){
      $interval.cancel($rootScope.countDown);
      delete $window.sessionStorage.eulaHash;
      delete $window.sessionStorage.eulaText;
      delete $window.sessionStorage.eulaAccepted;
      delete $window.sessionStorage.token;
      delete $window.sessionStorage.userName;
      delete $window.sessionStorage.realName;
      delete $window.sessionStorage.secondsLeft;
      delete $window.sessionStorage.profile;
      delete $window.sessionStorage.isDemo;
      delete $window.sessionStorage.userLicense;
      delete $window.sessionStorage.taxYear;
      delete $window.sessionStorage.cid;
      delete $window.sessionStorage.customerName;
      delete $window.sessionStorage.isManagedServices;
      delete $window.sessionStorage.MFAEnabled;
      delete $window.sessionStorage.phoneNumber;
      delete $window.sessionStorage.MFAToken;
      delete $window.sessionStorage.userId;
      delete $window.sessionStorage.fromAddPhone;
      if(redirect !== false){
        $location.path('/login');
      }
    };
    $rootScope.isManagedServices = false;
    return {
      login: function(userCredentials){
        var rpcConfig = {method: '_Login', params: ''};
        rpcConfig.params = [userCredentials.email.toUpperCase(), userCredentials.password];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      isUserLoggedIn: function(){
        var tk = $window.sessionStorage.token;
        return !(typeof tk === 'undefined' || tk === '' || tk === 'undefined');
      },
      callLogout: function(){
        var rpcConfig = {method: 'Logout', params: ''};
        rpcConfig.params = [];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      logout: function(redirect){
        /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
        this.callLogout().then(function(){
          internalLogout(redirect);
        }, function(){
          internalLogout(redirect);
        });
      },
      setSessionStorage: function(loginData){
        $window.sessionStorage.token = loginData.token;
        $window.sessionStorage.userName = loginData.userName;
        $window.sessionStorage.realName = loginData.realName;
        $window.sessionStorage.profile = UserService.setProfile(loginData.profiles).name;
        $window.sessionStorage.userId = (loginData.profiles) ? loginData.profiles[0].Username : null;
        $window.sessionStorage.expiredPassword = false;
        $window.sessionStorage.eulaText = loginData.eulaText;
        $window.sessionStorage.eulaHash = loginData.eulaHash;
        $window.sessionStorage.eulaAccepted = loginData.eulaAccepted;
        $window.sessionStorage.taxYear = loginData.taxYear;
        $window.sessionStorage.MFAEnabled = loginData.MFAEnabled;
        if (loginData.MFAEnabled === 'Y') {
          $window.sessionStorage.MFAToken = loginData.MFAToken;
          $window.sessionStorage.phoneNumber = (loginData.PhoneNumber && loginData.PhoneNumber !== 'N') ? loginData.PhoneNumber : null;
        }
      },
      setSessionStorageExpiredPassword: function(loginData){
        $window.sessionStorage.token = loginData.token;
        $window.sessionStorage.expiredPassword = true;
      },
      setUserCredentials: function(userCredentialsData){
        userCredentials = angular.copy(userCredentialsData);
        delete userCredentials.password;
      },
      loginSuccess: function(loginData){
        ManagedUserInformationService.findClient();
        $window.sessionStorage.sessionExpireSetting = loginData.hardExpiration + 60;
        $window.sessionStorage.secondsLeft = $window.sessionStorage.sessionExpireSetting;
        this.setSessionInterval();
        if(loginData.token){
          this.setSessionStorage(loginData);
          if(!loginData.eulaAccepted && loginData.profiles[0].ProfileName !== 'CNV_ACASOVOS'){
            $location.path('/license-agreement');
          }
          else{
            $location.path('/home');
            this.checkEmailToApprove();
          }
        }
      },
      loginMfa: function(loginData){
        if(loginData.token){
          $window.sessionStorage.sessionExpireSetting = loginData.hardExpiration + 60;          
          this.setSessionStorage(loginData);
        }
        if(loginData.MFAEnabled === 'null' && $window.sessionStorage.profile === 'CNV_ACAADMIN'){ 
          $location.path('/login').search({modalMFA:true});
          return;
        }
        if(loginData.PhoneNumber === 'N'){
          $location.path('/add-phone');
          return;
        }
        $location.path('/send-mfa');
      },
      changePasswordByToken: function(data, answerObject){
        var rpcConfig = {method: '_ChangePasswordByToken', params: ''};
        rpcConfig.params = [data.token, data.newPassword, answerObject];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      setSessionInterval: function(){
        var that = this;
        $interval.cancel($rootScope.countDown);
        $rootScope.countDown = $interval(function(){
          $window.sessionStorage.secondsLeft -= 10;
          if($window.sessionStorage.secondsLeft <= 0){
            that.checkBackendSession().then(function(){}, function(){
              $interval.cancel($rootScope.countDown);
              LockedScreenService.closeWindowsLoading();
              that.logout();
            });
            $interval.cancel($rootScope.countDown);
          }
        }, 10000);
      },
      checkBackendSession: function(){
        var rpcConfig = {method: 'CheckBackendSession', params: ''};
        rpcConfig.params = [];
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      checkEmailToApprove: function(){
        var searchParam = $location.search();
        if(searchParam.e === 'true'){
          $location.path('/send').search({section: searchParam.t, param: searchParam.param});
        }
        else{
          this.cleanParams();
        }
      },
      cleanParams: function(){
        $location.search({});
      },
      updatePhoneWithToken: function(token, phone){
        var rpcConfig = {method: '_addPhoneByToken', params: [token, phone]};
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      verifyMFATokenWithoutSession: function(otpValue){
        var rpcConfig = {method: '_VerifyTokenMFA', params: [$window.sessionStorage.MFAToken, otpValue]};
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      verifyMFATokenWithSession: function(otpValue){
        var rpcConfig = {method: 'VerifyUserOTP', params: [otpValue]};
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      resendOTP: function(){
        var rpcConfig = {method: 'SendOTPCode', params: []};
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      resendOTPToken: function(){
        var rpcConfig = {method: '_SendOTPCodeByToken', params: [$window.sessionStorage.MFAToken]};
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      validateMFAToken: function(){
        var rpcConfig = {method: '_ValidateMFAToken', params: [$window.sessionStorage.MFAToken]};
        return AuthResource.executeRpc(rpcConfig).$promise;
      },
      getOTPAttemptCount: function(){
        var rpcConfig = {method: '_GetOTPAttemptCount', params: [$window.sessionStorage.MFAToken]};
        return AuthResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);
